import { render, staticRenderFns } from "./CallCenter.vue?vue&type=template&id=145c8bff&scoped=true"
import script from "./CallCenter.vue?vue&type=script&lang=js"
export * from "./CallCenter.vue?vue&type=script&lang=js"
import style0 from "./CallCenter.vue?vue&type=style&index=0&id=145c8bff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145c8bff",
  null
  
)

export default component.exports